module.exports = "/assets/data/a785a796b2b96c2d29b5ef4190301e66-BN43.data.json";